"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconReporting = function SvgIconReporting(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "reporting icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Reporting Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.237 6.117a1.874 1.874 0 012.354.974l1.918 4.62a1.874 1.874 0 01-3.466 1.422l-1.918-4.62a1.876 1.876 0 011.112-2.396zM29.37 7.208l-1.868 4.502-.047.142a1.876 1.876 0 003.561 1.162l1.869-4.501.04-.122a1.874 1.874 0 00-3.554-1.183zM6.852 14.162a1.873 1.873 0 011.749-.157l.13.061 3.749 1.673a1.876 1.876 0 01-1.562 3.409l-.13-.06-3.749-1.674a1.876 1.876 0 01-.187-3.252zm32.427-.095a1.874 1.874 0 011.806 3.283l-.112.062-3.749 1.674a1.873 1.873 0 01-2.75-1.772c.039-.633.394-1.2.938-1.512l.12-.063 3.747-1.671zm-15.274.922a10.768 10.768 0 017.769 3.352 10.784 10.784 0 012.953 7.933c0 6.663-6.838 12.98-9.777 15.381-.26.23-.598.353-.944.346a1.41 1.41 0 01-.945-.346l-.424-.35c-3.123-2.626-9.353-8.671-9.353-15.031a10.783 10.783 0 012.953-7.933 10.768 10.768 0 017.769-3.352zm0 5.252a5.25 5.25 0 00-5.248 5.253 5.25 5.25 0 005.248 5.252 5.25 5.25 0 005.249-5.253 5.25 5.25 0 00-5.248-5.252z"
  }));
};

var _default = SvgIconReporting;
exports.default = _default;